import AccordionItemType from '../types/utils/AccordionItemType';
import { FunctionComponent } from 'react';
import classNames from 'classnames';

const AccordionItem: FunctionComponent<AccordionItemType> = ({
  keyItem,
  header,
  headerAction,
  footer,
  active = false,
  setActive = () => {},
  index,
  children,
}) => {
  return (
    <div className="accordion-item bg-white" key={keyItem}>
      <h2 className={`accordion-header d-flex align-items-center ${active ? ' active' : ''}`} id={`headingCargo${keyItem}`}>
        <button
          className={classNames(
            'accordion-button',
            !active && 'collapsed',
            'flex-grow-1',
            headerAction ? 'border-end me-1' : '',
          )}
          type="button"
          data-bs-toggle="collapse"
          data-bs-target={`#collapseCandidaturasCargo${keyItem}`}
          aria-expanded="true"
          aria-controls={`collapseCandidaturasCargo${keyItem}`}
          onClick={(e) => {
            if (active) {
              setActive(-1);
            } else {
              setActive(index);
            }
          }}
        >
          {header}
        </button>
        {headerAction && <div className="m-1 d-flex flex-row gap-2">{headerAction}</div>}
      </h2>
      <div
        id={`collapseCandidaturasCargo${keyItem}`}
        className={classNames('accordion-collapse collapse bg-primary-050', active && 'show')}
        aria-labelledby={`headingCargo${keyItem}`}
        data-bs-parent="#accordionCargosCandidaturas"
      >
        <div className={'p-3'}>{children}</div>
        {footer && <div className={classNames('accordion-footer')}>{footer}</div>}
      </div>
    </div>
  );
};

export default AccordionItem;
